import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../i18n";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { googleSession } = useAuth();
  const { t } = useI18n();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { nav("/login", { replace: true }); return; }
      try {
        await googleSession(sessionId);
        window.history.replaceState(null, "", "/app");
        nav("/app", { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, googleSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center gc-gradient-navy text-white">
      <div className="text-center">
        <div className="h-10 w-10 rounded-full border-2 border-white/30 border-t-white animate-spin mx-auto" />
        <div className="mt-4 text-sm text-white/70">{t("loading")}</div>
      </div>
    </div>
  );
}
